import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { RFMConfigLevel } from '../interfaces/RFMConfigLevel';
import { NavLink, useLocation } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

const toggleButtons = [
  {
    label: 'Business Unit',
    value: RFMConfigLevel.BUSINESS_UNIT,
    to: './',
  },
  {
    label: 'Product Hierarchy',
    value: RFMConfigLevel.PRODUCT_HIERARCHY,
    to: './product-hierarchy',
  },
];

const Home = () => {
  const location = useLocation();

  // Determine current level based on URL
  const getCurrentLevel = () => {
    if (location.pathname.includes('product-hierarchy')) {
      return RFMConfigLevel.PRODUCT_HIERARCHY;
    }
    return RFMConfigLevel.BUSINESS_UNIT;
  };

  const currentLevel = getCurrentLevel();

  return (
    <Box>
      <ToggleButtonGroup
        sx={{ mb: '1rem' }}
        value={currentLevel}
        fullWidth
        exclusive
      >
        {toggleButtons.map(({ label, value, to }) => (
          <ToggleButton
            key={value}
            value={value}
            component={NavLink}
            to={to}
            end={false}
          >
            {label} Level
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      <Outlet />
    </Box>
  );
};

export default Home;
